import { ChevronRight } from "lucide-react";
import React, { ReactNode } from "react";

interface DashboardTileProps {
    title: string;
    onNavigate?: () => void;
    children?: ReactNode;
}

const DashboardTile: React.FC<DashboardTileProps> = ({ title, onNavigate, children }) => {
    return (
        <div className="p-6 rounded-lg border border-gray-300 bg-white mb-4">
            <div className="flex items-center justify-between">
                <h2 
                    className="text-xl font-semibold text-blue-500 leading-none flex items-center"
                    onClick={onNavigate}
                >
                    {title}
                </h2>
                {onNavigate && (
                    <ChevronRight 
                        className="w-7 h-7 flex-shrink-0 text-blue-500" 
                        onClick={onNavigate} 
                    />
                )}
            </div>

            <div className="mt-4">
                {children}
            </div>
        </div>
    );
};

export default DashboardTile;